export default __webpack_public_path__ + "static/media/dashboard-icon.99371016.svg";